// @flow

import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { log } from '../../utils/jsUtils';

import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import ArrowDropDown from '@mui/icons-material/ArrowDropDown';

import { useTheme } from '@mui/material/styles';
import feedMobileStyles from '../Feed/Styles/CommonFeedMobile.Style';

import FeedRow from '../Feed/FeedRow';
import type { Task } from '../../services/SPBackend';
import { selectUnits, selectRequests } from '../../reduxStore/modules/feed/selectors';
import { useI18n } from '../../contexts/I18nContext';
import commonFeedTableStyles from "../Feed/Styles/CommonFeedTable.Style";

type Props = {
  // tasks: Array<Task>,
  markInProgress: Function,
  triggerAssignDialog: Function
};

const FeedTable = ({ markInProgress, triggerAssignDialog }: Props) => {
  const theme = useTheme();
  const history = useHistory();
  const units = useSelector(selectUnits);
  const i18n = useI18n();
  const tasks = useSelector(selectRequests);

  useEffect(() => {
    log('[FeedTable] Received tasks:', tasks);
    log('[FeedTable] Tasks length:', tasks?.length);
  }, [tasks]);

  const goToRequest = (requestId) => (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    history.push(`/member/${requestId}`);
  };

  if (!tasks || tasks.length === 0) {
    log('[FeedTable] No tasks available');
    return null;
  }

  return [
    // Mobile layout - shows below 1000px
    <Grid
      key='tableMobile'
      container
      direction='column'
      sx={{
        ...feedMobileStyles.mobileFeedCtr(theme),
        display: 'flex',
        '@media (min-width: 1000px)': {
          display: 'none'
        }
      }}
    >
      {tasks.map((task: Task, i) => (
        <FeedRow
          key={`task-${task._id}`}
          request={task}
          markInProgress={markInProgress}
          triggerOpenAssignTaskDialog={triggerAssignDialog}
          units={units}
          goToRequest={goToRequest}
          readonly={false}
          mobileOnly={true}
        />
      ))}
    </Grid>,

    // Desktop CSS Grid layout - shows at 1000px and above
    <Box
      key='tableDesktop'
      id='divToPrint'
      sx={{
        ...commonFeedTableStyles.feedTableGrid(theme),
        display: 'none',
        '@media (min-width: 1000px)': {
          display: 'grid'
        }
      }}
    >
        {/* Header Row */}
        <Box sx={commonFeedTableStyles.feedTableGridHeaderRow(theme)}>
          <Box sx={{
            ...commonFeedTableStyles.feedTableGridHeaderCell(theme),
            paddingLeft: theme.spacing(1)
          }}>
            <span style={{display: 'block', width: 18, marginRight: theme.spacing(1)}} />
            {i18n.t('Customer')}
          </Box>
          <Box sx={{
            ...commonFeedTableStyles.feedTableGridHeaderCell(theme),
            paddingLeft: theme.spacing(2)
          }}>
            {i18n.t('Tag')}
          </Box>
          <Box sx={commonFeedTableStyles.feedTableGridHeaderCell(theme)}>
            {i18n.t('Subject')}
          </Box>
          <Box sx={commonFeedTableStyles.feedTableGridHeaderCell(theme)}>
            {i18n.t('Staff')}
          </Box>
          <Box sx={{
            ...commonFeedTableStyles.feedTableGridHeaderCell(theme),
            justifyContent: 'flex-end',
            paddingRight: theme.spacing(3)
          }}>
            <span style={{position: 'relative', top: -2}}>
              <ArrowDropDown />
            </span>
            {i18n.t('Last Updated')}
          </Box>
        </Box>

        {/* Data Rows */}
        {tasks.map((task: Task, i) => (
          <FeedRow
            key={`task-${task._id}`}
            request={task}
            markInProgress={markInProgress}
            triggerOpenAssignTaskDialog={triggerAssignDialog}
            units={units}
            goToRequest={goToRequest}
            readonly={false}
            useGridLayout={true}
          />
        ))}
    </Box>
  ];
};

export default FeedTable;